module.exports = __webpack_public_path__ + "img/Logo-Brand-default.5dc62b43.svg";